import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetInvalidReply } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default () => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    
    const url = ApiUrl2 + 'config-invalidreply-view';

    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
    }; 

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS({});

        try{
            var resJson = await response.json()
            if(resJson !== '' || resJson !== null){
                data = fromJS(resJson);
                data = data.get('data');
            }else{
                data = fromJS({});
            }    
        }catch(ex){
            data = fromJS({});
        }
    }

    dispatch({ type: GetInvalidReply, data: fromJS(data), time: new Date().getTime() });
};